import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { CoachForm } from "../../../components/coach/CoachForm";
import { useYearContext } from "../../../hooks/useYearContext";
import { ContentShell } from "../../../layout/ContentShell";
import { coaches_path } from "../../../routes";

export default function CoachCreate() {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.post(pathWithYearContext(coaches_path), values);

  return (
    <ContentShell title="Neuer Coach" onBack={() => router.get(pathWithYearContext(coaches_path))}>
      <CoachForm submitButtonLabel="Erstellen" onSubmit={onSubmit} />
    </ContentShell>
  );
}
